export const isObject = (object: unknown): object is Record<string, unknown> => {
    return typeof object === "object" && object !== null;
};

export const isObjectEmpty = (object: unknown): boolean => {
    if (!isObject(object)) {
        throw new Error("Object is not an object");
    }

    return Object.keys(object).length === 0;
};
